import { Box, Image } from '@chakra-ui/react';

import { TextMedium } from 'UiKit/typography';
import ShoppingBagIcon from 'Asset/icon/shopping-bag.svg';

import styles from './styles.module.css';

const BadgeEcomerce = ({ ecommerce = {}, accountName }) => {
  const { color, logo, name } = ecommerce;

  return (
    <Box bg={color} className={styles['badge-ecommerce__container']}>
      <Image src={logo} width={'16px'} height={'16px'} fallbackSrc={ShoppingBagIcon} alt={`${name}-logo`} />
      <TextMedium className={`${styles['badge-ecommerce__text']}`}>{accountName}</TextMedium>
    </Box>
  );
};

export default BadgeEcomerce;
